module.exports = __webpack_public_path__ + "pc/img/file_chm.1e138379.png";